import * as React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import ptBR from 'date-fns/locale/pt-BR';
import { format } from 'date-fns';

function isoToDateLocal(iso) {
  if (!iso) return null;
  const [y, m, d] = iso.split('-').map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d);
}

export default function DatePickerBR({
  valueISO,
  onChangeISO,
  label,
  sx,
  slotProps,
  ...rest
}) {
  const value = React.useMemo(() => isoToDateLocal(valueISO), [valueISO]);

  const handleChange = newDate => {
    if (!(newDate instanceof Date) || isNaN(newDate.getTime())) {
      onChangeISO?.('');
      return;
    }
    onChangeISO?.(format(newDate, 'yyyy-MM-dd'));
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
      <DatePicker
        label={label}
        value={value}
        onChange={handleChange}
        format="dd/MM/yyyy"
        sx={sx}
        slotProps={{
          textField: { size: 'small', sx: { width: 168 } },
          ...slotProps,
        }}
        {...rest}
      />
    </LocalizationProvider>
  );
}
